import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { accountModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { SendTwoFactorAuthCodeModel, TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import { LoginService } from './login.service';
import { finalize } from 'rxjs/operators';
import { CommonModule } from '@node_modules/@angular/common';
import { FormsModule } from '@node_modules/@angular/forms';
import { NgbModule } from '@node_modules/@ng-bootstrap/ng-bootstrap';
import { AbpModule } from '@node_modules/abp-ng2-module';
import { UtilsModule } from '@shared/utils/utils.module';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
    selector: 'send-two-factor-code',
    templateUrl: './send-two-factor-code.component.html',
    animations: [accountModuleAnimation()],
    standalone: true,
    imports: [FormsModule, NgbModule, UtilsModule, AbpModule, CommonModule, NgOtpInputModule, RouterModule]
})
export class SendTwoFactorCodeComponent extends AppComponentBase implements OnInit {

    selectedTwoFactorProvider: string;
    submitting = false;
    @Input() isPopup: boolean = false;
    @Input() isWebFacing: boolean = false;
    @Output() stepUpdate: EventEmitter<number> = new EventEmitter<number>()

    constructor(
        injector: Injector,
        public loginService: LoginService,
        private _tokenAuthService: TokenAuthServiceProxy,
        private _router: Router
    ) {
        super(injector);
    }

    canActivate(): boolean {
        if (this.loginService.authenticateModel &&
            this.loginService.authenticateResult &&
            this.loginService.authenticateResult.twoFactorAuthProviders &&
            this.loginService.authenticateResult.twoFactorAuthProviders.length
        ) {
            return true;
        }

        return false;
    }

    ngOnInit(): void {
        this.selectedTwoFactorProvider = this.loginService.authenticateResult.twoFactorAuthProviders[0];
    }

    submit(): void {
        const model = new SendTwoFactorAuthCodeModel();
        model.userId = this.loginService.authenticateResult.userId;
        model.provider = this.selectedTwoFactorProvider;

        this.submitting = true;
        this._tokenAuthService
            .sendTwoFactorAuthCode(model)
            .pipe(finalize(() => this.submitting = false))
            .subscribe(() => {
                if (this.isPopup) {
                    if (this.stepUpdate)
                        this.stepUpdate.emit(3); // Emit an event to update the step in the parent component
                }
                else
                    this._router.navigate(['account/verify-code']);
            });
    }

    returnToLogin(): void {
        if (this.isPopup) {
            if (this.stepUpdate)
                this.stepUpdate.emit(1); // Emit an event to update the step in the parent component
        }
        else
            this._router.navigate(['/login']);
    }
}
